module.exports = __webpack_public_path__ + "img/icon52.85fa8fd9.png";